export class FollowOnModelDTO {
  id = 0;
  uuid = '';
  period: Date;
  name: string = NEW_MODEL_NAME;
  newCompaniesInvestment = 0;
  lastSaveText? = '';
  isFirstSave? = true;
  lastModifiedDate?: Date;
  createdBy: string;
  constructor(selectedPeriod?: Date) {
    this.period = selectedPeriod;
  }
}

export const NEW_MODEL_NAME = 'New model' as const;
